export enum ReportEvaluationState 
{
    Pendiente = 0,
    Aprobado = 1, 
    NoAprobado = 2
}